const doc = [({"en":({"adminConstantNewsletterStatus":({"created":"Created", "sending":"Sending", "sent":"Sent"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;